import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { updateSlackAPI } from "api/slackAPI";
import { DeleteSlackAPI } from "api/slackAPI";
import { GetSlackAPI } from "api/slackAPI";
import { CreateSlackAPI } from "api/slackAPI";

const handleThunkError = (err, rejectWithValue) => {
  return rejectWithValue(
    err?.response?.data || {
      success: false,
      message: "Something went wrong",
    }
  );
};

const initialState = {
  slacks: [],
  loading: false,
  placeId: "",
};

export const createSlack = createAsyncThunk(
  "slack/createSlacks",
  async (data, { rejectWithValue }) => {
    console.log(data, "<==data");
    try {
      const response = await CreateSlackAPI(data);
      return response.data;
    } catch (err) {
      console.log("postSlack error ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const getSlack = createAsyncThunk(
  "slack/getSlacks",
  async (placeId, { rejectWithValue }) => {
    try {
      const response = await GetSlackAPI(placeId);
      return response.data;
    } catch (err) {
      console.log("get slack error ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const deleteSlack = createAsyncThunk(
  "slack/deleteSlack",
  async (data, { rejectWithValue }) => {
    try {
      const response = await DeleteSlackAPI(data);
      return response.data;
    } catch (err) {
      console.log("Delete error ======>", err);
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const updateSlack = createAsyncThunk(
  "slack/updateSlack",
  async (updateSlackData, { rejectWithValue }) => {
    console.log(updateSlackData, "<<update slack data");
    try {
      const response = await updateSlackAPI(updateSlackData);
      return response.data;
    } catch (err) {
      return handleThunkError(err, rejectWithValue);
    }
  }
);

export const slackSlice = createSlice({
  name: "slacks",
  initialState,
  reducers: {
    setSlacks: (state, action) => {
      state.slacks = action.payload;
    },
    setPlaceIdForSlacks: (state, action) => {
      state.placeId = action.payload;
    },
  },
  extraReducers: (builder) =>
    builder
      .addCase(getSlack.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSlack.fulfilled, (state, { payload }) => {
        state.slacks = payload.data;
        state.loading = false;
      })
      .addCase(getSlack.rejected, (state) => {
        state.loading = false;
      }),
});

export const { setSlacks, setPlaceIdForSlacks } = slackSlice.actions;
export default slackSlice.reducer;
